module.exports = __webpack_public_path__ + "img/kh.641d8826.svg";